import { v1 } from "../api";

export async function checkToken({ accessToken = "" }) {
  const response = await v1.get("auth/check-token", {
    params: { accessToken },
  });

  return response.data;
}

export async function login({ username, password }) {
  const response = await v1.post("auth/login", { username, password });

  return response.data;
}

export async function getProfile() {
  const response = await v1.get("auth/profile");

  return response.data;
}

export async function logout() {
  window.localStorage.removeItem("token");

  return true;
}
